import { ICON_PATHS, type IconName } from './paths';

export type { IconName };

export interface IconProps {
  name: IconName;
  /** Design sizes: default 20px, `sm` 16px, `xs` 14px, `lg` 24px. */
  size?: 'sm' | 'xs' | 'lg';
  className?: string;
  style?: React.CSSProperties;
}

/** Inline SVG icon from the design sprite (`svg.i`). Decorative: always aria-hidden. */
export function Icon({ name, size, className, style }: IconProps) {
  const cls = ['i', size, className].filter(Boolean).join(' ');
  return (
    <svg
      className={cls}
      style={style}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      // Static, trusted markup generated from design/b-glass.html.
      dangerouslySetInnerHTML={{ __html: ICON_PATHS[name] }}
    />
  );
}
